import { useTranslation } from 'react-i18next';

import {
    Avatar,
    Body1,
    Body2,
    Heading1,
    HorizontalDivider,
    IconLocalShipping,
    IconSavings,
    IconSupportAgent,
    Stack,
    Subtitle1,
} from '@myphx-engineering/phx-design-system';

export const WhyChooseLilly = () => {
    const { t } = useTranslation();

    return (
        <Stack py="xxl" gap="lg">
            <Stack align="center">
                <Heading1>{t('unauth.home.whyChoose.heading')}</Heading1>
                <Body1 ta="center">
                    {t('unauth.home.whyChoose.description')}
                </Body1>
            </Stack>
            <Stack gap="sm">
                <Stack p="sm" align="center" gap="xxs">
                    <Avatar AvatarIcon={IconLocalShipping} />
                    <Subtitle1>
                        {t('unauth.home.freeHomeDelivery.title')}
                    </Subtitle1>
                    <Body2 ta="center">
                        {t('unauth.home.freeHomeDelivery.description')}
                    </Body2>
                </Stack>
                <HorizontalDivider />
                <Stack p="sm" align="center" gap="xxs">
                    <Avatar AvatarIcon={IconSavings} />
                    <Subtitle1>
                        {t('unauth.home.costAndSavings.title')}
                    </Subtitle1>
                    <Body2 ta="center">
                        {t('unauth.home.costAndSavings.description')}
                    </Body2>
                </Stack>
                <HorizontalDivider />
                <Stack p="sm" align="center" gap="xxs">
                    <Avatar AvatarIcon={IconSupportAgent} />
                    <Subtitle1>
                        {t('unauth.home.expertSupport.title')}
                    </Subtitle1>
                    <Body2 ta="center">
                        {t('unauth.home.expertSupport.description')}
                    </Body2>
                </Stack>
            </Stack>
        </Stack>
    );
};
